import { lazyUnsubscribe } from 'owa-notification';
import { removeAssetSubscription } from './AssetSubscriptions';
import handleAssetNotification from './handleAssetNotification';

export default function unsubscribeFromAssetNotifications(subscriptionId: string) {
    const subscriptionInfo = removeAssetSubscription(subscriptionId);
    if (subscriptionInfo) {
        lazyUnsubscribe.importAndExecute(
            subscriptionInfo.notificationSubscription,
            handleAssetNotification
        );
    }
}
